import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 360px;
  min-height: 220px;
  background: #fff;
  border: 1px solid #3089d7;
  border-radius: 20px;
  padding: 20px;
  align-self: center;
  margin: 0px 30px 20px;

  h1 {
    color: #3089d7;
    font-weight: bold;
  }

  h2 {
    color: #3089d7;
  }

  li {
    color: #3089d7;
  }
`;
